import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text, useStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import {getHerobannerGradient} from '../utils'
import useDamImage from '../../../custom-hooks/use-dam-image'
import {EditorialVideo} from '../video'
import SanitizedHtml from '../../html-sanitizer'

export const PLPWhiteBanner = ({
    isMaskHeaderActive = true,
    heading,
    bodycopy,
    image,
    isVideo = false,
    video,
    variant = 'default',
}) => {
    const styles = useStyleConfig('PlpWhiteBanner', {variant})
    const damImage = useDamImage(image)
    const gradient = getHerobannerGradient('middle-left', 'black', isMaskHeaderActive)

    return (
        <Box data-testid="plp-white-banner-container" {...styles.container}>
            <Box
                data-testid={`plp-white-banner-${isVideo ? 'video' : 'image'}`}
                pb={{base: remCalc(24), xl: 0}}
            >
                {isVideo ? (
                    <EditorialVideo data={video} />
                ) : (
                    (damImage.url || image?.alt) && (
                        <AspectRatio ratio={damImage.ratio}>
                            <Img src={damImage.url} alt={image?.alt || ''} />
                        </AspectRatio>
                    )
                )}
            </Box>
            <Flex
                {...styles.textblock}
                bgImage={{
                    base: 'none',
                    xl: gradient || 'none',
                }}
            >
                {heading && (
                    <Text
                        data-testid="plp-white-banner-heading"
                        textStyle="head-xlarge"
                        fontWeight="medium"
                        color={{base: 'text.default', xl: 'text.inverse'}}
                        pb={{base: remCalc(24), xl: remCalc(28)}}
                        maxW={{base: 'auto', md: remCalc(642), xl: remCalc(593)}}
                    >
                        {heading}
                    </Text>
                )}
                {bodycopy && (
                    <SanitizedHtml
                        as={Text}
                        html={bodycopy}
                        data-testid="plp-white-banner-bodycopy"
                        textStyle="body-xlarge"
                        fontWeight="normal"
                        color={{base: 'text.default', xl: 'text.inverse'}}
                        maxW={{base: 'auto', md: remCalc(642), xl: remCalc(593)}}
                    />
                )}
            </Flex>
        </Box>
    )
}

PLPWhiteBanner.propTypes = {
    isMaskHeaderActive: PropTypes.bool,
    heading: PropTypes.string,
    bodycopy: PropTypes.string,
    image: PropTypes.shape(),
    isVideo: PropTypes.bool,
    video: PropTypes.shape(),
    variant: PropTypes.string,
}
